import aakash from '../img/aakash_new.JPG';
import linkedin from '../img/linkedin.svg';
import github from '../img/github.svg'
import mail from '../img/mail.svg';
import resume from '../img/resume.png'
import styled from 'styled-components';
import {StyledAbout,StyledDescription,StyledImage,StyledHide} from '../styles.js';
import {motion} from 'framer-motion';
import {titleAnimation,fadeAnimation,photoAnimation} from '../Animation';

import Wave from './Wave.js';
const AboutSection = () => {


    return (
        <StyledAbout>
            <StyledDescription>
                <motion.div className = "title">
                    {/* <StyledHide> */}
                        {/* <motion.h2 variants = {titleAnimation} initial = "hidden" animate="show" >Hi! I'm</motion.h2> */}
                    {/* </StyledHide> */}
                    <StyledHide>
                        <motion.h2 variants = {titleAnimation} initial = "hidden" animate="show" >
                          Hi, I'm <span>Aakash</span>
                        </motion.h2>
                    </StyledHide>
                    {/* <StyledHide> */}
                        {/* <h2>true.</h2> */}
                    {/* </StyledHide> */}
                </motion.div>
                <motion.p variants = {fadeAnimation} >  
                I'm currently working as a Data Scientist at <span> <a style={{ padding: '3rem 0rem', fontSize:'1.4rem',color:'#23d997' }} href="https://www.mayan.co/" target="_blank" rel="noreferrer"> Mayan </a> </span>  which is a Y Combinator backed growth automation platform for Amazon sellers. I graduated from Indiana University, Bloomington in May 2021 having completed by Masters in Data Science. I love building data products from the ground up. Apart from data science, my passions include entrepreneurship, product management,hiking and playing any kind of outdoor sports 🎾 ⚽
                {/* <a href="https://www.mayan.co/" target="_blank" rel="noopener noreferrer" >  Mayan </a>   */}
                
                </motion.p>
                
                {/* <motion.button variants = {fadeAnimation}> Contact us </motion.button> */}
                <StyledCards>
        <StyledCard>
            <div className="icon">
            <a href="https://www.linkedin.com/in/aakashahuja3095/" target="_blank" rel="noreferrer">
                <img src={linkedin} alt="efficient"/>
            </a>
                </div>
                  
        </StyledCard>

        <StyledCard>
            <div className="icon">
                <a href="https://github.com/AakashAhuja30" target="_blank" rel="noreferrer">
                <img src={github} alt="efficient"/>
                </a>
                </div>
                  
        </StyledCard>

        <StyledCard>
            <div className="icon">
                <a href="mailto:aakashahuja30495@gmail.com" target="_blank" rel="noopener noreferrer">
                <img src={mail} alt="efficient"/>
                </a>
                </div>
                  
        </StyledCard>

        <StyledCard>
            <div className="icon">
                <a href="https://drive.google.com/file/d/1o7xBloJVMsRJK6P_4tVKg4cCyaWDySDD/view?usp=sharing" target="_blank" rel="noopener noreferrer">
                <img style={{height:'40px'}} src={resume} alt="efficient"/>
                </a>
                </div>
                  
        </StyledCard>


        </StyledCards>


            </StyledDescription>
            <StyledImage>

                <motion.img variants = {photoAnimation} src={aakash} alt="guy with a camera"/>
            </StyledImage>
            <Wave />
        </StyledAbout>
    )

}

const StyledCards = styled.div`
display:flex;
padding:2rem;
padding-right:0.5rem;
width:100%;
align-items:center; 
/* flex-wrap:wrap;  */
`

const StyledCard = styled.div`
flex-basis:15rem;
margin-bottom:2rem;
.icon{
    display:flex; 
    /* align-items: center; */
    size:20px;

}
`



export default AboutSection;